exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".plaid-success-icon{width:16px;margin-right:8px;vertical-align:middle}.image-text-large-button.plaid-disabled .wrapper{background-color:gray;opacity:.5}", ""]);

// exports
